// Check for YYYY-MM-DD format - SA-20390

import moment from "moment";
import { registerV2Enum } from "src/app/appsettings";

// and format to DD.MM.YYYY
export const formatDateString = (value: string): string => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;

  if (regex.test(value)) {
    const [year, month, day] = value.split("-");
    return `${day}.${month}.${year}`;
  }

  return value;
};

export const parseDateOfBirth = (dob: string) => {
  const parsedDate = moment(dob, registerV2Enum.DATE_OF_BIRTH_FORMAT_NEW, true);

  if (!parsedDate.isValid()) {
    return "Invalid date of birth"; 
  }

  return parsedDate.format(registerV2Enum.DATE_OF_BIRTH_FORMAT_NEW);
}


/**
 * 
 * @param date required format is: DD.MM.YYYY
 * @returns 
 */
export const checkDateStringFormat = (date: string) => {
  const regex = /^\d{2}\.\d{2}\.\d{4}$/;
  return regex.test(date);
};

